import { AfterViewChecked, Directive, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Position } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Directive()
export class PositionBase implements AfterViewChecked {
  @Input()
  public get item(): Position {
    return this._item;
  }
  public set item(item: Position) {
    this._item = item;
    this.sumProtection =
      this._item?.orderExecutionTypesForProtection?.reduce((sum, x) => sum + x.protectedQuantityByOrderExecutionType, 0) ?? 0;
  }
  @Input() public actionsEnabled = false;
  @Input() public isEditEntryQuoteMode = false;
  @Input() public isEditProtectOrderMode = false;
  @Input() public isCurrentlyEditing = false;
  @Input() public isCurrentlyProtectOrderEditing = false;
  @Input() public currentEntryQuote?: string;
  @Input() public protectOrderVisible = false;
  @Input() public isAddTagMode = false;
  @Input() public isCurrentlyAddTagMode = false;

  @Output() public editNote = new EventEmitter<void>();
  @Output() public editEntryQuote = new EventEmitter<void>();
  @Output() public updateEntryQuote = new EventEmitter<number>();
  @Output() public activateProtectOrderMode = new EventEmitter<Position>();
  @Output() public addTagMode = new EventEmitter<void>();
  @Output() public cancelTagMode = new EventEmitter<void>();

  @ViewChild('entryQuote') public input: ElementRef;

  public commonRoutes = commonRoutes;
  public isEntryQuoteError = false;
  public sumProtection = 0;
  private _item;

  ngAfterViewChecked(): void {
    if (this.isCurrentlyEditing) {
      const input = this.input.nativeElement as HTMLTextAreaElement;
      input.focus();
    }
  }

  public validateEntryQuoteAndUpdate = (): void => {
    if (!this.currentEntryQuote) {
      this.currentEntryQuote = this.item.avgEntryQuoteOriginal.toString();
      this.updateEntryQuote.emit(this.item.avgEntryQuoteOriginal);
      return;
    }
    const newEntryQuote = Number(this.currentEntryQuote.replace(',', '.'));
    this.isEntryQuoteError = isNaN(newEntryQuote) || newEntryQuote < 0;
    !this.isEntryQuoteError && this.updateEntryQuote.emit(newEntryQuote);
  };
}
